customElements.get('product-form') ||
  customElements.define(
    'product-form',
    class extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.formIdInput = this.form.querySelector('[name=id]');
        this.formIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.stickyAtcButton = document.getElementById(`StickyAtcSubmitButton-${this.dataset.section}`);
        this.skipCart = this.formIdInput.dataset.skipCart === 'true';
        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        this.bundleDeals = document.getElementById(`bundle-deals-${this.dataset.section}`);
        this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.section}`);
        this.customFields = document.querySelectorAll(`[id^='CustomField-${this.dataset.section}-']`);
        this.variantInputs = this.form.querySelector('.product-form__variants');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (document.body.classList.contains('mce-buy') && !window.mceBuySelectionValid?.()) return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        if (this.stickyAtcButton) {
          this.stickyAtcButton.classList.add('loading');
          this.stickyAtcButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        let isMultiItem = false;

        if (this.variantInputs) {
          this.variantInputs.innerHTML = '';
        }

        if (this.bundleDeals) {
          let html = '';
          isMultiItem = true;
          for (let i = 0; i < this.bundleDeals.formVariants.length; i++) {
            const variant = this.bundleDeals.formVariants[i];
            html += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`;
            html += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
          }
          this.variantInputs.innerHTML = html;
        } else if (this.quantityBreaks && this.variantInputs && this.quantityBreaks.formVariants.length > 0) {
          let html = '';
          isMultiItem = true;
          for (let i = 0; i < this.quantityBreaks.formVariants.length; i++) {
            const variant = this.quantityBreaks.formVariants[i];
            html += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`;
            html += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
            this.customFields.forEach((field) => {
              html += `<input type="hidden" name="items[${i}][properties][${field.fieldName}]" value="${field.prevValue}">`;
            });
          }
          this.variantInputs.innerHTML = html;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // 追加商品は通常カートでは既存items配列で送る。二重追加を避ける。
        for (const key of [...formData.keys()]) { if (key.startsWith('shopify-additional-items[')) formData.delete(key); }

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((s) => s.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (isMultiItem) {
          const optionNames = this.dataset.options ? this.dataset.options.split(',') : [];
          const keysToDelete = ['id', 'quantity', ...optionNames];
          for (let i = 0; i < keysToDelete.length; i++) {
            formData.delete(keysToDelete[i]);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            // Only treat HTTP error statuses (4xx/5xx) as errors, not status: 200
            if (parsedState.status && parsedState.status >= 400) {
              this.handleErrorMessage(parsedState.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (this.skipCart) {
              window.location = '/checkout';
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(parsedState);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(parsedState);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            if (this.stickyAtcButton) {
              this.stickyAtcButton.classList.remove('loading');
              this.stickyAtcButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
            }

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }

      handleErrorMessage(message = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !message);
        if (message) {
          this.errorMessage.textContent = message;
        }
      }
    }
  );
